<template>
  <section id="mainContainer">
    <adminHeader></adminHeader>
    <section class="admin-mid-container">
      <div class="admin-custom-row admin-page-row" id="leftMenuSlideBox">
        <adminNavigation></adminNavigation>
        <section class="admin-right-sidebar" @click="handleOutsideClick">
          <div class="admin-right-sidebar-in">
            <div class="admin-right-sidebar-in-top">
              <div class="admin-custom-row">
                <div class="admin-right-sidebar-in-top-left">
                  <h1>
                    {{ constants.MANAGE_EMAIL_TEMPLATE_TEXT }}
                  </h1>
                  <div class="admin-page-type-links">
                    <ul>
                      <li>
                        <a
                          id="activeLink"
                          href="#"
                          :class="{ active: activeTab === 'active' }"
                          @click="switchView('active')"
                        >
                          {{ constants.ACTIVE_LINK }}
                          <span>{{ counts.active }}</span>
                        </a>
                      </li>
                      <li>
                        <a
                          id="inActiveLink"
                          href="#"
                          :class="{ active: activeTab === 'inActive' }"
                          @click="switchView('inActive')"
                        >
                          {{ constants.INACTIVE_LINK }}
                          <span>{{ counts.inActive }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="admin-right-sidebar-in-top-right">
                  <div class="admin-right-sidebar-in-top-right-top">
                    <div class="admin-search-box">
                      <input
                        id="seachEmailTempalteInput"
                        type="text"
                        placeholder="Search Email Template"
                        v-model="searchedText"
                        @keyup.enter="
                          fetchEmailTemplates(activeTab),
                            fetchCounts(searchedText)
                        "
                      />
                    </div>
                    <div class="admin-add-btn">
                      <button
                        id="addBannerBtn"
                        class="admin-btn-primary primary-icon-btn"
                        @click="openEmailTemplateForm"
                      >
                        <i class="add-icon"></i>
                        {{ constants.ADD_NEW_EMAIL_TEMPLATE_TEXT }}
                      </button>
                    </div>
                  </div>
                  <div
                    class="admin-right-sidebar-in-top-right-btm"
                    v-if="selectedEmailTemplates.length > 1"
                  >
                    <div class="tags">
                      <ul>
                        <li>
                          <span
                            >{{ selectedEmailTemplates.length }} entries
                            selected</span
                          >
                          <button
                            id="tagCloseBtn"
                            @click="
                              (selectedEmailTemplates = []), (selectAll = false)
                            "
                          ></button>
                        </li>
                      </ul>
                    </div>
                    <div class="delete-all-btn-link">
                      <button
                        class="btn_link"
                        id="deleteAllBtn"
                        data-bs-toggle="modal"
                        data-bs-target="#deletePop"
                        @click="setDeleteMode('all')"
                      >
                        {{ constants.DELETE_ALL_BUTTON }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="newFormOpened" class="white-bg-border add-new-section">
              <div class="add-banner-image-section">
                <h2>
                  {{ constants.ADD_NEW_EMAIL_TEMPLATE_TEXT }}
                </h2>
                <div class="email-template-form-row">
                  <div class="add-banner-image-box">
                    <form
                      id="addBannerImageForm"
                      @submit.prevent="submitNewEmailTemplateForm"
                    >
                      <div class="admin-input-field">
                        <label>
                          {{ constants.SELECT_USER_LABEL }}
                        </label>
                        <!-- <VueSelect
                          v-model="newEmailTemplateData.roles"
                          :options="roles"
                          class="multi-select-box"
                          :is-multi="false"
                          placeholder="Select User"
                        ></VueSelect> -->
                        <select
                          id="selectUserSelectBox"
                          class="admin-selectbox"
                          v-model="newEmailTemplateData.roles"
                        >
                          <option value="null" disabled>
                            Select user
                          </option>
                          <option
                            :key="key"
                            :value="value.id"
                            v-for="(value, key) in roles"
                          >
                            {{ value.name }}
                          </option>
                        </select>
                        <div
                          class="error-msg"
                          v-if="!newEmailTemplateData.roles && roleErrorMsg"
                        >
                          {{ roleErrorMsg }}
                        </div>
                      </div>
                      <div class="admin-input-field">
                        <label>
                          {{ constants.EMAIL_TITLE_LABEL }}
                        </label>
                        <input
                          id="emailTitleInput"
                          type="text"
                          placeholder="Enter your email title"
                          v-model="newEmailTemplateData.email_title"
                          @focus="setActiveInput"
                        />
                        <div
                          class="error-msg"
                          v-if="
                            !newEmailTemplateData.email_title &&
                            emailTitleErrorMsg
                          "
                        >
                          {{ emailTitleErrorMsg }}
                        </div>
                      </div>
                      <div class="admin-input-field">
                        <label>
                          {{ constants.NOTIFICATION_TYPE_LABEL }}
                        </label>
                        <select
                          id="selectNotificationTypeSelectBox"
                          class="admin-selectbox"
                          v-model="newEmailTemplateData.email_notification_type"
                          @change="validateRoleAndNotificationType(false)"
                        >
                          <option value="null" disabled>
                            Select notification type
                          </option>
                          <option
                            :key="key"
                            :value="value.id"
                            v-for="(value, key) in availableNotificationTypes"
                          >
                            {{ value.title }}
                          </option>
                        </select>
                        <div
                          class="error-msg"
                          v-if="emailNotificationTypeErrorMsg"
                        >
                          {{ emailNotificationTypeErrorMsg }}
                        </div>
                      </div>
                      <div class="admin-input-field">
                        <label>
                          {{ constants.EMAIL_RECEIVER_TYPE_LABEL }}
                        </label>
                        <div class="admin-checkbox-input-row">
                          <div class="admin-checkbox-input">
                            <input
                              name="cssCheckbox"
                              id="emailCheckInput"
                              type="checkbox"
                              class="css-checkbox"
                              v-model="newEmailTemplateData.emailChecked"
                            />
                            <label for="emailCheckInput">
                              {{ constants.EMAIL_LABEL }}
                            </label>
                          </div>
                          <!--- <div class="admin-checkbox-input">
                            <input
                              name="cssCheckbox"
                              id="websiteCheckInput"
                              type="checkbox"
                              class="css-checkbox"
                              v-model="newEmailTemplateData.websiteChecked"
                            />
                            <label for="websiteCheckInput">
                              {{ constants.WEBSITE_LABEL }}
                            </label>
                          </div> --->
                        </div>
                        <div
                          class="error-msg"
                          v-if="
                            !newEmailTemplateData.websiteChecked &&
                            !newEmailTemplateData.emailChecked &&
                            notificationReceiverTypeErrorMsg
                          "
                        >
                          {{ notificationReceiverTypeErrorMsg }}
                        </div>
                      </div>
                      <div
                        class="admin-input-field"
                        v-if="newEmailTemplateData.websiteChecked"
                      >
                        <label>
                          {{ constants.WEB_MOBILE_MESSAGE_LABEL }}
                        </label>
                        <ckeditor
                          placeholder="Web or mobile message"
                          class="text-editer"
                          id="servicesPgSubHdInput"
                          :editor="editor"
                          v-model="newEmailTemplateData.web_or_mobile_content"
                          :config="Config"
                        ></ckeditor>
                        <div
                          class="error-msg"
                          v-if="
                            !newEmailTemplateData.web_or_mobile_content &&
                            webOrMobileContentErrorMsg
                          "
                        >
                          {{ webOrMobileContentErrorMsg }}
                        </div>
                      </div>
                      <div
                        class="admin-input-field"
                        v-if="newEmailTemplateData.emailChecked"
                      >
                        <label>
                          {{ constants.EMAIL_MESSAGE_LABEL }}
                        </label>
                        <ckeditor
                          placeholder="Email message"
                          class="text-editer"
                          id="servicesPgSubHdInput"
                          :editor="editor"
                          v-model="newEmailTemplateData.email_content"
                          :config="Config"
                          @ready="onNewEditorReady"
                        ></ckeditor>
                        <div
                          class="error-msg"
                          v-if="emailContentErrorMsg"
                        >
                          {{ emailContentErrorMsg }}
                        </div>
                      </div>
                      <div class="admin-input-field">
                        <label>
                          {{ constants.ACTIVE_INACTIVE_LABEL }}
                        </label>
                        <div
                          class="active-inactive-radio"
                          @click="toggleStatus(newEmailTemplateData)"
                        >
                          <input
                            id="ActiveInput"
                            type="radio"
                            name="foo"
                            class="active-radio"
                            :value="1"
                            v-model="newEmailTemplateData.status"
                          />
                          <input
                            id="InactiveInput"
                            type="radio"
                            name="foo"
                            class="inactive-radio"
                            :value="0"
                            v-model="newEmailTemplateData.status"
                          />
                          <div class="active-inactive-radio-img"></div>
                        </div>
                      </div>
                      <div class="admin-input-field-submit">
                        <button
                          id="bnrPgSubmitBtn"
                          class="admin-btn-outline-primary"
                          type="submit"
                          :disabled="isFormSubmitting"
                        >
                          {{ constants.SUBMIT_BUTTON }}
                        </button>
                        <button
                          id="bnrPgCancelBtn"
                          class="admin-btn-outline-secondary"
                          @click="cancelNewEmailTemplateForm"
                          type="button"
                        >
                          {{ constants.CANCEL_BUTTON }}
                        </button>
                      </div>
                    </form>
                  </div>

                  <div class="email-tags">
                    <div class="add-email-tags">
                      <div class="add-new-tags-input">
                        <input
                          type="text"
                          placeholder="Add a new tag"
                          v-model="newTag.key"
                          @focus="
                            isListOpenedForEditTag = false;
                            isListOpenedForNewTag = false;
                            emailTags = emailTags.map((tag) => ({
                              ...tag,
                              editing: false,
                            }));
                          "
                        />
                        <div
                          class="error-msg"
                          v-if="!newTag.key && newTagErrors.keyError"
                        >
                          {{ newTagErrors.keyError }}
                        </div>
                      </div>
                      <div class="add-new-tags-select">
                        <div
                          class="lmd-custom-select-box"
                          :class="{
                            'lmd-custom-select-box-show': isListOpenedForNewTag,
                          }"
                        >
                          <div class="lmd-custom-select-box-top">
                            <div class="lmd-custom-select-box-input">
                              <input
                                type="text"
                                v-model="newTag.value"
                                placeholder="Enter or select value"
                                @focus="
                                  isListOpenedForEditTag = false;
                                  isListOpenedForNewTag = false;
                                  emailTags = emailTags.map((tag) => ({
                                    ...tag,
                                    editing: false,
                                  }));
                                "
                                @input="newTag.referenced_key = null"
                              />
                            </div>
                            <button
                              @click="
                                openAndCloseList(false);
                                isListOpenedForEditTag = false;
                                emailTags = emailTags.map((tag) => ({
                                  ...tag,
                                  editing: false,
                                }));
                              "
                              class="lmd-custom-select-box-btn"
                            ></button>
                          </div>

                          <div class="lmd-custom-select-box-inner">
                            <ul>
                              <li v-if="emailTags.length === 0">
                                No data
                              </li>
                              <li
                                :key="tag.id"
                                v-for="tag in emailTags"
                                @click="selectKey(tag.id, false)"
                              >
                                {{ tag.key }}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="add-new-tags-btn">
                        <button
                          class="admin-btn-outline-primary"
                          id="addEmailTagBtn"
                          @click="addFilterKey"
                        >
                          {{ constants.ADD_BUTTON }}
                        </button>
                      </div>
                    </div>
                    <div class="email-tags-list">
                      <div
                        v-for="tag in emailTags"
                        :key="tag.id"
                        class="email-tags-box"
                        :class="{ 'tags-editable': tag.editing }"
                      >
                        <div class="email-tags-box-save">
                          <div @click="insertTagIntoEditor(tag.key)" style="cursor: pointer">
                            <span
                            >{{ tag.key }}
                          </span>
                          <span v-if="!tag.is_predefined && tag.effective_value"
                            >&nbsp;:&nbsp;{{ tag.effective_value }}</span
                          >
                          </div>                      
                          <button
                            v-if="!tag.is_predefined"
                            class="tags-edit-btn"
                            @click="
                              startEditTag(tag);
                              newTag.key = '';
                              newTag.value = null;
                              newTag.referenced_key = null;
                              isListOpenedForNewTag = false;
                            "
                          ></button>
                          <button
                            v-if="!tag.is_predefined"
                            class="tags-delete-btn"
                            @click="deleteTag(tag.id)"
                          ></button>
                        </div>
                        <div class="email-tags-box-edit">
                          <div class="email-tags-box-edit-input">
                            <input
                              type="text"
                              placeholder="Enter your tag"
                              v-model="editTag.key"
                              @focus="
                                isListOpenedForNewTag = false;
                                newTag.key = '';
                                newTag.value = null;
                                newTag.referenced_key = null;
                              "
                            />
                            <div
                              class="error-msg"
                              v-if="!editTag.key && editTagErrors.keyError"
                            >
                              {{ editTagErrors.keyError }}
                            </div>
                          </div>
                          <div class="add-new-tags-select">
                            <div
                              class="lmd-custom-select-box"
                              :class="{
                                'lmd-custom-select-box-show':
                                  isListOpenedForEditTag,
                              }"
                            >
                              <div class="lmd-custom-select-box-top">
                                <div class="lmd-custom-select-box-input">
                                  <input
                                    type="text"
                                    v-model="editTag.value"
                                    placeholder="Enter or select value"
                                    @focus="isListOpenedForEditTag = false"
                                    @input="editTag.referenced_key = null"
                                  />
                                </div>
                                <button
                                  @click="openAndCloseList(true)"
                                  class="lmd-custom-select-box-btn"
                                ></button>
                              </div>

                              <div class="lmd-custom-select-box-inner">
                                <ul>
                                  <li v-if="emailTags.length === 0">
                                    No data
                                  </li>
                                  <li
                                    :key="tag.id"
                                    v-for="tag in emailTags"
                                    @click="selectKey(tag.id, true)"
                                  >
                                    {{ tag.key }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div class="email-tags-box-edit-btns">
                            <button
                              class="tags-edit-save-btn"
                              id="saveEmailTagEditBtn"
                              @click="saveTagEdit()"
                            ></button>
                            <button
                              class="tags-edit-delete-btn"
                              id="deleteEmailTagEditBtn"
                              @click="cancelTagEdit()"
                            ></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              :class="[
                'admin-item-list-section email-template-section',
                { 'show-edit-item-outer': editFormOpened },
              ]"
              v-if="emailTemplateData.length > 0"
            >
              <div class="admin-item-list-section-in">
                <div class="admin-item-list-section-scroll">
                  <div class="admin-item-list-top">
                    <div class="admin-item-list-row">
                      <div class="admin-item-checkbox">
                        <div class="admin-checkbox-input">
                          <input
                            name="cssCheckbox"
                            id="allCheckInput"
                            type="checkbox"
                            class="css-checkbox"
                            @change="toggleSelectAll"
                            :checked="selectAll === true"
                          />
                          <label for="allCheckInput"></label>
                        </div>
                      </div>
                      <div class="admin-item-email-template-name text-limit" @click="toggleSort('email_title')" style="cursor: pointer;">
                        {{ constants.TITLE_LABEL }}
                        <button v-if="sortBy === 'email_title' || sortBy === '-email_title'" class="sorting-btn" :class="{ 'sorted': sortBy === '-email_title' }"></button>
                      </div>

                      <div class="admin-item-actions-2">
                        {{ constants.ACTIONS_LABEL }}
                      </div>
                    </div>
                  </div>
                  <div class="admin-item-list-btm">
                    <div
                      :class="[
                        'admin-item-box',
                        { 'show-edit-item': emailTemplate.editing },
                      ]"
                      :key="emailTemplate.id"
                      v-for="(emailTemplate, index) in emailTemplateData"
                    >
                      <div class="admin-item-box-top">
                        <div class="admin-item-list-row">
                          <div class="admin-item-checkbox">
                            <div class="admin-checkbox-input">
                              <input
                                name="cssCheckbox"
                                :id="'checkItemOneInput' + emailTemplate.id"
                                type="checkbox"
                                class="css-checkbox"
                                @change="
                                  toggleEmailTemplateSelection(emailTemplate.id)
                                "
                                :checked="
                                  selectedEmailTemplates.includes(
                                    emailTemplate.id
                                  )
                                "
                              />
                              <label
                                :for="'checkItemOneInput' + emailTemplate.id"
                              ></label>
                            </div>
                          </div>

                          <div
                            class="admin-item-email-template-name text-limit"
                          >
                            {{ emailTemplate.email_title }}
                          </div>

                          <div class="admin-item-actions-2">
                            <ul class="admin-action-link">
                              <li>
                                <button
                                  id="bnrPgEditBtn"
                                  @click="editEmailTemplate(index)"
                                >
                                  {{ constants.EDIT_BUTTON }}
                                </button>
                              </li>
                              <li>
                                <button
                                  id="bnrPgDeleteBtn"
                                  data-bs-toggle="modal"
                                  data-bs-target="#deletePop"
                                  @click="
                                    setDeleteMode('single', emailTemplate.id),
                                      (newFormOpened = false),
                                      cancelEditEmailTemplateForm()
                                  "
                                >
                                  {{ constants.DELETE_BUTTON }}
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="admin-item-box-btm">
                        <div class="add-banner-image-section">
                          <h2>
                            {{ constants.EDIT_EMAIL_TEMPLATE_TEXT }}
                          </h2>
                          <div class="email-template-form-row">
                            <div class="add-banner-image-box">
                              <form
                                id="editBannerImageForm"
                                @submit.prevent="submitEditEmailTemplateForm"
                              >
                                <div class="admin-input-field">
                                  <label>
                                    {{ constants.SELECT_USER_LABEL }}
                                  </label>
                                  <!-- <VueSelect
                                    v-model="editEmailTemplateData.roles"
                                    :options="roles"
                                    class="multi-select-box"
                                    :is-multi="true"
                                    placeholder="Select User"
                                  ></VueSelect> -->
                                  <select
                                    id="selectUserSelectBox"
                                    class="admin-selectbox"
                                    v-model="editEmailTemplateData.roles"
                                  >
                                    <option value="null" disabled>
                                      Select user
                                    </option>
                                    <option
                                      :key="key"
                                      :value="value.id"
                                      v-for="(value, key) in roles"
                                    >
                                      {{ value.name }}
                                    </option>
                                  </select>
                                  <div
                                    class="error-msg"
                                    v-if="
                                      !editEmailTemplateData.roles &&
                                      editRoleErrorMsg
                                    "
                                  >
                                    {{ editRoleErrorMsg }}
                                  </div>
                                </div>
                                <div class="admin-input-field">
                                  <label>
                                    {{ constants.EMAIL_TITLE_LABEL }}
                                  </label>
                                  <input
                                    id="emailTitleInput"
                                    type="text"
                                    placeholder="Enter your email title"
                                    v-model="editEmailTemplateData.email_title"
                                    @focus="setActiveInput"
                                  />
                                  <div
                                    class="error-msg"
                                    v-if="
                                      !editEmailTemplateData.email_title &&
                                      editEmailTitleErrorMsg
                                    "
                                  >
                                    {{ editEmailTitleErrorMsg }}
                                  </div>
                                </div>
                                <div class="admin-input-field">
                                  <label>
                                    {{ constants.NOTIFICATION_TYPE_LABEL }}
                                  </label>
                                  <select
                                    id="selectNotificationTypeSelectBox"
                                    class="admin-selectbox"
                                    v-model="
                                      editEmailTemplateData.email_notification_type
                                    "
                                    @change="validateRoleAndNotificationType(true)"
                                  >
                                    <option value="null" disabled>
                                      Select notification type
                                    </option>
                                    <option
                                      :key="key"
                                      :value="value.id"
                                      v-for="(value, key) in notification_types"
                                    >
                                      {{ value.title }}
                                    </option>
                                  </select>
                                  <div
                                    class="error-msg"
                                    v-if="editEmailNotificationTypeErrorMsg"
                                  >
                                    {{ editEmailNotificationTypeErrorMsg }}
                                  </div>
                                </div>
                                <div class="admin-input-field">
                                  <label>
                                    {{ constants.EMAIL_RECEIVER_TYPE_LABEL }}
                                  </label>
                                  <div class="admin-checkbox-input-row">
                                    <div class="admin-checkbox-input">
                                      <input
                                        name="cssCheckbox"
                                        id="emailCheckInput"
                                        type="checkbox"
                                        class="css-checkbox"
                                        v-model="
                                          editEmailTemplateData.emailChecked
                                        "
                                      />
                                      <label for="emailCheckInput">
                                        {{ constants.EMAIL_LABEL }}
                                      </label>
                                    </div>
                                    <!-- <div class="admin-checkbox-input">
                                      <input
                                        name="cssCheckbox"
                                        id="websiteCheckInput"
                                        type="checkbox"
                                        class="css-checkbox"
                                        v-model="
                                          editEmailTemplateData.websiteChecked
                                        "
                                      />
                                      <label for="websiteCheckInput">
                                        {{ constants.WEBSITE_LABEL }}
                                      </label>
                                    </div> -->
                                  </div>
                                  <div
                                    class="error-msg"
                                    v-if="
                                      !editEmailTemplateData.websiteChecked &&
                                      !editEmailTemplateData.emailChecked &&
                                      editNotificationReceiverTypeErrorMsg
                                    "
                                  >
                                    {{ editNotificationReceiverTypeErrorMsg }}
                                  </div>
                                </div>
                                <div
                                  class="admin-input-field"
                                  v-if="editEmailTemplateData.websiteChecked"
                                >
                                  <label>
                                    {{ constants.WEB_MOBILE_MESSAGE_LABEL }}
                                  </label>
                                  <ckeditor
                                    placeholder="Web or mobile message"
                                    class="text-editer"
                                    id="servicesPgSubHdInput"
                                    :editor="editor"
                                    v-model="
                                      editEmailTemplateData.web_or_mobile_content
                                    "
                                    :config="Config"
                                  ></ckeditor>
                                  <div
                                    class="error-msg"
                                    v-if="
                                      !editEmailTemplateData.web_or_mobile_content &&
                                      editWebOrMobileContentErrorMsg
                                    "
                                  >
                                    {{ editWebOrMobileContentErrorMsg }}
                                  </div>
                                </div>
                                <div
                                  class="admin-input-field"
                                  v-if="editEmailTemplateData.emailChecked"
                                >
                                  <label>
                                    {{ constants.EMAIL_MESSAGE_LABEL }}
                                  </label>
                                  <ckeditor
                                    placeholder="Email message"
                                    class="text-editer"
                                    id="servicesPgSubHdInput"
                                    :editor="editor"
                                    v-model="
                                      editEmailTemplateData.email_content
                                    "
                                    :config="Config"
                                    @ready="onEditEditorReady"
                                  ></ckeditor>
                                  <div
                                    class="error-msg"
                                    v-if="editEmailContentErrorMsg"
                                  >
                                    {{ editEmailContentErrorMsg }}
                                  </div>
                                </div>
                                <div class="admin-input-field">
                                  <label>
                                    {{ constants.ACTIVE_INACTIVE_LABEL }}
                                  </label>
                                  <div
                                    class="active-inactive-radio"
                                    @click="toggleStatus(editEmailTemplateData)"
                                  >
                                    <input
                                      id="ActiveInput"
                                      type="radio"
                                      name="foo"
                                      class="active-radio"
                                      :value="1"
                                      v-model="editEmailTemplateData.status"
                                    />
                                    <input
                                      id="InactiveInput"
                                      type="radio"
                                      name="foo"
                                      class="inactive-radio"
                                      :value="0"
                                      v-model="editEmailTemplateData.status"
                                    />
                                    <div
                                      class="active-inactive-radio-img"
                                    ></div>
                                  </div>
                                </div>
                                <div class="admin-input-field-submit">
                                  <button
                                    id="bnrPgSubmitBtn"
                                    class="admin-btn-outline-primary"
                                    type="submit"
                                    :disabled="isFormSubmitting"
                                  >
                                    {{ constants.SUBMIT_BUTTON }}
                                  </button>
                                  <button
                                    id="bnrPgCancelBtn"
                                    class="admin-btn-outline-secondary"
                                    type="button"
                                    @click="cancelEditEmailTemplateForm"
                                  >
                                    {{ constants.CANCEL_BUTTON }}
                                  </button>
                                </div>
                              </form>
                            </div>
                            <div class="email-tags">
                              <div class="add-email-tags">
                                <div class="add-new-tags-input">
                                  <input
                                    type="text"
                                    placeholder="Add a new tag"
                                    v-model="newTag.key"
                                    @focus="
                                      isListOpenedForEditTag = false;
                                      isListOpenedForNewTag = false;
                                      emailTags = emailTags.map((tag) => ({
                                        ...tag,
                                        editing: false,
                                      }));
                                    "
                                  />
                                  <div
                                    class="error-msg"
                                    v-if="!newTag.key && newTagErrors.keyError"
                                  >
                                    {{ newTagErrors.keyError }}
                                  </div>
                                </div>
                                <div class="add-new-tags-select">
                                  <div
                                    class="lmd-custom-select-box"
                                    :class="{
                                      'lmd-custom-select-box-show':
                                        isListOpenedForNewTag,
                                    }"
                                  >
                                    <div class="lmd-custom-select-box-top">
                                      <div class="lmd-custom-select-box-input">
                                        <input
                                          type="text"
                                          v-model="newTag.value"
                                          placeholder="Enter or select value"
                                          @focus="
                                            isListOpenedForEditTag = false;
                                            isListOpenedForNewTag = false;
                                            emailTags = emailTags.map(
                                              (tag) => ({
                                                ...tag,
                                                editing: false,
                                              })
                                            );
                                          "
                                          @input="newTag.referenced_key = null"
                                        />
                                      </div>
                                      <button
                                        @click="
                                          openAndCloseList(false);
                                          isListOpenedForEditTag = false;
                                          emailTags = emailTags.map((tag) => ({
                                            ...tag,
                                            editing: false,
                                          }));
                                        "
                                        class="lmd-custom-select-box-btn"
                                      ></button>
                                    </div>

                                    <div class="lmd-custom-select-box-inner">
                                      <ul>
                                        <li v-if="emailTags.length === 0">
                                          No data
                                        </li>
                                        <li
                                          :key="tag.id"
                                          v-for="tag in emailTags"
                                          @click="selectKey(tag.id, false)"
                                        >
                                          {{ tag.key }}
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div class="add-new-tags-btn">
                                  <button
                                    class="admin-btn-outline-primary"
                                    id="addEmailTagBtn"
                                    @click="addFilterKey"
                                  >
                                    {{ constants.ADD_BUTTON }}
                                  </button>
                                </div>
                              </div>
                              <div class="email-tags-list">
                                <div
                                  v-for="tag in emailTags"
                                  :key="tag.id"
                                  class="email-tags-box"
                                  :class="{ 'tags-editable': tag.editing }"
                                >
                                  <div class="email-tags-box-save">
                                    <div @click="insertTagIntoEditor(tag.key)" style="cursor: pointer">
                                    <span
                                      >{{ tag.key }}
                                    </span>
                                    <span
                                      v-if="
                                        !tag.is_predefined &&
                                        tag.effective_value
                                      "
                                      >&nbsp;:&nbsp;{{
                                        tag.effective_value
                                      }}</span
                                    >
                                    </div>
                                    <button
                                      v-if="!tag.is_predefined"
                                      class="tags-edit-btn"
                                      @click="
                                        startEditTag(tag);
                                        newTag.key = '';
                                        newTag.value = null;
                                        newTag.referenced_key = null;
                                        isListOpenedForNewTag = false;
                                      "
                                    ></button>
                                    <button
                                      v-if="!tag.is_predefined"
                                      class="tags-delete-btn"
                                      @click="deleteTag(tag.id)"
                                    ></button>
                                  </div>
                                  <div class="email-tags-box-edit">
                                    <div class="email-tags-box-edit-input">
                                      <input
                                        type="text"
                                        placeholder="Enter your tag"
                                        v-model="editTag.key"
                                        @focus="
                                          isListOpenedForNewTag = false;
                                          newTag.key = '';
                                          newTag.value = null;
                                          newTag.referenced_key = null;
                                        "
                                      />
                                      <div
                                        class="error-msg"
                                        v-if="
                                          !editTag.key && editTagErrors.keyError
                                        "
                                      >
                                        {{ editTagErrors.keyError }}
                                      </div>
                                    </div>
                                    <div class="add-new-tags-select">
                                      <div
                                        class="lmd-custom-select-box"
                                        :class="{
                                          'lmd-custom-select-box-show':
                                            isListOpenedForEditTag,
                                        }"
                                      >
                                        <div class="lmd-custom-select-box-top">
                                          <div
                                            class="lmd-custom-select-box-input"
                                          >
                                            <input
                                              type="text"
                                              v-model="editTag.value"
                                              placeholder="Enter or select value"
                                              @focus="
                                                isListOpenedForEditTag = false
                                              "
                                              @input="
                                                editTag.referenced_key = null
                                              "
                                            />
                                          </div>
                                          <button
                                            @click="openAndCloseList(true)"
                                            class="lmd-custom-select-box-btn"
                                          ></button>
                                        </div>

                                        <div
                                          class="lmd-custom-select-box-inner"
                                        >
                                          <ul>
                                            <li v-if="emailTags.length === 0">
                                              No data
                                            </li>
                                            <li
                                              :key="tag.id"
                                              v-for="tag in emailTags"
                                              @click="selectKey(tag.id, true)"
                                            >
                                              {{ tag.key }}
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="email-tags-box-edit-btns">
                                      <button
                                        class="tags-edit-save-btn"
                                        id="saveEmailTagEditBtn"
                                        @click="saveTagEdit()"
                                      ></button>
                                      <button
                                        class="tags-edit-delete-btn"
                                        id="deleteEmailTagEditBtn"
                                        @click="cancelTagEdit()"
                                      ></button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="admin-pagination-section">
                <div class="custom-row">
                  <div class="item-show-selectbox">
                    <select
                      id="paginationSelectBox"
                      v-model="limit"
                      @change="handleLimitChange"
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                    <span> {{ constants.ENTRIES_PER_PAGE_LABEL }} </span>
                  </div>
                  <div
                    class="admin-pagination"
                    id="paginationBox"
                    v-if="totalPages > 1"
                  >
                    <ul>
                      <li
                        v-if="currentPage !== 1"
                        @click="changePage(currentPage - 1)"
                      >
                        <a href="#" class="pagination-previous"></a>
                      </li>
                      <li
                        v-for="page in visiblePages"
                        :key="page"
                        @click="changePage(page)"
                        v-if="totalPages != 1"
                      >
                        <a href="#" :class="{ active: currentPage === page }">{{
                          page
                        }}</a>
                      </li>
                      <li
                        v-if="currentPage !== totalPages"
                        @click="changePage(currentPage + 1)"
                      >
                        <a href="#" class="pagination-next"></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p>No data to display</p>
            </div>
          </div>
        </section>
      </div>
    </section>
    <footer class="admin-site-footer">
      <div class="container">
        {{ constants.COPYRIGHT_TEXT }}
      </div>
    </footer>
    <div
      class="modal fade confirmation-popup"
      id="deletePop"
      tabindex="-1"
      role="dialog"
      aria-labelledby="deleteModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="confirmation-popup-icon">
            <i>
              <img
                src="@/assets/images/admin-img/light_delete-outline.svg"
                alt=""
              />
            </i>
          </div>
          <div class="confirmation-popup-mid">
            <p>{{ constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT }}</p>
          </div>
          <div class="confirmation-popup-btm">
            <button
              id="popNoBtn"
              class="admin-btn-outline-secondary"
              data-bs-dismiss="modal"
            >
              {{ constants.NO_BUTTON }}
            </button>
            <button
              id="popYesBtn"
              class="admin-btn-outline-primary"
              data-bs-dismiss="modal"
              @click="confirmDelete"
            >
              {{ constants.YES_BUTTON }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Admin.json";
import adminHeader from "@/components/adminHeader.vue";
import adminNavigation from "@/components/adminNavigation.vue";
import { RouteLocationNormalized, NavigationGuardNext } from "vue-router";
import { API_BASE_URL } from "@/config/api.config";
import axios from "axios";
import VueSelect from "vue3-select-component";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CustomUploadAdapterPlugin } from "@/utils/CustomUploadAdapterPlugin";
import Swal from "sweetalert2";
import {
  getPaginationLimit,
  setPaginationLimit,
} from "@/utils/paginationUtils";

interface Role {
  id: number;
  name: string;
  status: number;
}

interface NotificationType {
  id: number;
  title: string;
  filter_keys: string[];
  status: number;
}

interface EmailTags {
  id: number;
  key: string;
  value: string | null;
  effective_value: string;
  is_predefined: boolean;
  referenced_key: number | null;
  editing?: boolean;
}

interface EmailTemplateData {
  id: number;
  roles: number | null;
  email_title: string;
  web_or_mobile_content?: string;
  email_content?: string;
  email_notification_type: number | null;
  notification_receiver_type: number;
  status: number;
  emailChecked: boolean;
  websiteChecked: boolean;
  editing?: boolean;
}

export default defineComponent({
  name: "EmailTemplate",
  components: {
    adminHeader,
    adminNavigation,
    VueSelect,
  },
  data() {
    return {
      constants,
      editor: ClassicEditor,
      roles: [] as Role[],
      notification_types: [] as NotificationType[],
      emailTemplateData: [] as EmailTemplateData[],
      newEmailTemplateData: {
        id: 0,
        roles: null,
        email_title: "",
        email_notification_type: null,
        notification_receiver_type: 1,
        web_or_mobile_content: "",
        email_content: "",
        status: 0,
        emailChecked: true,
        websiteChecked: false,
      } as EmailTemplateData,
      editEmailTemplateData: {
        id: 0,
        roles: null,
        email_title: "",
        email_notification_type: null,
        notification_receiver_type: 1,
        web_or_mobile_content: "",
        email_content: "",
        status: 0,
        emailChecked: false,
        websiteChecked: false,
      } as EmailTemplateData,
      newFormOpened: false,
      editFormOpened: false,
      roleErrorMsg: "",
      emailTitleErrorMsg: "",
      emailNotificationTypeErrorMsg: "",
      notificationReceiverTypeErrorMsg: "",
      emailContentErrorMsg: "",
      webOrMobileContentErrorMsg: "",
      isFormSubmitting: false,
      editRoleErrorMsg: "",
      editEmailTitleErrorMsg: "",
      editEmailNotificationTypeErrorMsg: "",
      editNotificationReceiverTypeErrorMsg: "",
      editEmailContentErrorMsg: "",
      editWebOrMobileContentErrorMsg: "",
      activeTab: "active",
      counts: {
        active: 0,
        inActive: 0,
      } as any,
      limit: 10,
      totalPages: 0,
      currentPage: 1,
      searchedText: "",
      searchTempVar: "",
      emailTemplateToDelete: null as number | null,
      deleteMode: "all" as "all" | "single",
      selectedEmailTemplates: [] as number[],
      selectAll: false,
      sortBy: "-created_at" as string,
      emailTags: [] as EmailTags[],
      isListOpenedForNewTag: false,
      isListOpenedForEditTag: false,
      newTag: {
        key: "",
        value: null as string | null,
        referenced_key: null as number | null,
      },
      newTagErrors: {
        keyError: "",
        valueError: "",
      },
      editTag: {
        id: null as number | null,
        key: "",
        value: null as string | null,
        referenced_key: null as number | null,
      },
      editTagErrors: {
        keyError: "",
        valueError: "",
      },
      selected: [] as any,
      lastActiveEditor: null as any,
      lastActiveInput: null as HTMLInputElement | null,
      usedNotificationTypeIds: [] as number[],
    };
  },
  computed: {
    Config(): any {
      return {
        extraPlugins: [CustomUploadAdapterPlugin],
        toolbar: {
          items: [
            "heading",
            "|",
            "bold",
            "italic",
            "link",
            "underline",
            "bulletedList",
            "numberedList",
            "|",
            "outdent",
            "indent",
            "|",
            "imageUpload",
            "|",
            "undo",
            "redo",
            "|",
            "insertTable",
          ],
        },
        image: {
          toolbar: [
            "imageTextAlternative",
            "imageStyle:full",
            "imageStyle:side",
          ],
        },
      };
    },
    selectedNotificationFilterKeys(): string[] {
      const selectedType = this.notification_types.find(
        (type) =>
          type.id === Number(this.newEmailTemplateData.email_notification_type)
      );
      return selectedType ? selectedType.filter_keys : [];
    },
    selectedEditNotificationFilterKeys(): string[] {
      const selectedType = this.notification_types.find(
        (type) =>
          type.id === Number(this.editEmailTemplateData.email_notification_type)
      );
      return selectedType ? selectedType.filter_keys : [];
    },
    visiblePages() {
      const maxVisiblePages = 5;
      const halfMaxVisiblePages = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - halfMaxVisiblePages, 1);
      let end = start + maxVisiblePages - 1;

      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }

      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    availableNotificationTypes() {
      return this.notification_types.filter(
        (type) => !this.usedNotificationTypeIds.includes(type.id)
      );
    },
  },
  watch: {
    "newEmailTemplateData.emailChecked": function () {
      this.updateNotificationReceiverType(false);
    },
    "newEmailTemplateData.websiteChecked": function () {
      this.updateNotificationReceiverType(false);
    },
    "editEmailTemplateData.emailChecked": function () {
      this.updateNotificationReceiverType(true);
    },
    "editEmailTemplateData.websiteChecked": function () {
      this.updateNotificationReceiverType(true);
    },
    "newEmailTemplateData.roles": function () {
      this.validateRoleAndNotificationType(false);
    },
    "newEmailTemplateData.email_notification_type": function () {
      this.validateRoleAndNotificationType(false);
    },
    "editEmailTemplateData.roles": function () {
      this.validateRoleAndNotificationType(true);
    },
    "editEmailTemplateData.email_notification_type": function () {
      this.validateRoleAndNotificationType(true);
    },
  },
  beforeRouteEnter(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn !== "true") {
      next({ name: "Login" });
    } else {
      next();
    }
  },
  created() {
    this.limit = getPaginationLimit("emailTemplates", 10);
    this.fetchCounts();
    this.fetchRoles();
    this.fetchNotificationTypes();
    this.fetchEmailTags();
    this.fetchAllEmailTemplates();
    this.fetchEmailTemplates();
  },
  mounted() {},
  methods: {
    validateEmailTags(content: string): string[] {
      // Extract all tags in the format [TagName] from the content
      const tagPattern = /\[([^\]]+)\]/g;
      const matches = content.matchAll(tagPattern);
      const usedTags = new Set<string>();
      
      for (const match of matches) {
        usedTags.add(match[1]);
      }
      
      // Get available tag keys
      const availableTagKeys = this.emailTags.map(tag => tag.key);
      
      // Find invalid tags
      const invalidTags = Array.from(usedTags).filter(
        tag => !availableTagKeys.includes(tag)
      );
      
      return invalidTags;
    },
    async fetchRoles() {
      const params = new URLSearchParams();
      params.append("status", "1");
      try {
        const response = await axios.get(`${API_BASE_URL}/roles/?${params}`);
        this.roles = response?.data;
      } catch (error: any) {
        console.error("Error fetching roles:", error);
      }
    },
    async fetchNotificationTypes() {
      const params = new URLSearchParams();
      params.append("status", "1");
      try {
        const response = await axios.get(
          `${API_BASE_URL}/email-notification-types/?${params}`
        );
        this.notification_types = response?.data;
      } catch (error: any) {
        console.error("Error fetching notification types:", error);
      }
    },
    async fetchEmailTemplates(
      status = "active",
      limit?: number,
      skip = 0,
      // @ts-expect-error
      sortBy = this.sortBy
    ) {
      const effectiveLimit = limit ?? this.limit;

      let url = `${API_BASE_URL}/email-templates/`;
      const params = new URLSearchParams();
      if (status === "active") params.append("status", "1");
      else if (status === "inActive") params.append("status", "0");

      if (this.searchedText && !this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = this.searchedText;
      }
      if (!this.searchedText && this.searchTempVar) {
        this.currentPage = 1;
        this.searchTempVar = "";
      }

      params.append("limit", effectiveLimit.toString());
      params.append("skip", skip.toString());
      if (this.searchedText) {
        params.append("searchedText", this.searchedText);
      }
      params.append("sort_by", sortBy);
      try {
        const response = await axios.get(`${url}?${params.toString()}`);
        this.emailTemplateData = (response?.data || []).map((template: any) => ({
          ...template,
          roles: Array.isArray(template.roles) ? template.roles[0] || null : template.roles || null,
        }));
      } catch (error: any) {
        console.error("Error fetching email templates:", error);
      }
    },
    openEmailTemplateForm() {
      if (this.notification_types.length > 0 && this.availableNotificationTypes.length === 0) {
        Swal.fire({
          icon: "error",
          text: "All notification types are currently used. Please delete an existing template to free up a notification type.",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      this.cancelNewEmailTemplateForm();
      this.newFormOpened = true;
      this.cancelEditEmailTemplateForm();
      this.selectedEmailTemplates = [];
      this.selectAll = false;
    },
    toggleStatus(emailTemplate: { status: number }) {
      emailTemplate.status = emailTemplate.status === 1 ? 0 : 1;
    },
    updateNotificationReceiverType(isEdit: boolean) {
      const data = isEdit
        ? this.editEmailTemplateData
        : this.newEmailTemplateData;
      if (data.emailChecked && data.websiteChecked) {
        data.notification_receiver_type = 3;
      } else if (data.emailChecked) {
        data.notification_receiver_type = 1;
      } else if (data.websiteChecked) {
        data.notification_receiver_type = 2;
      } else {
        data.notification_receiver_type = 1;
      }
    },
    async submitNewEmailTemplateForm() {
      this.roleErrorMsg = "";
      this.emailTitleErrorMsg = "";
      this.emailNotificationTypeErrorMsg = "";
      this.notificationReceiverTypeErrorMsg = "";
      this.emailContentErrorMsg = "";
      this.webOrMobileContentErrorMsg = "";

      if (!this.newEmailTemplateData.roles) {
        this.roleErrorMsg = "Please select a role.";
      }

      if (!this.newEmailTemplateData.email_title) {
        this.emailTitleErrorMsg = "Email title is required.";
      }

      if (!this.newEmailTemplateData.email_notification_type) {
        this.emailNotificationTypeErrorMsg = "Notification type is required.";
      }

      this.validateRoleAndNotificationType(false);

      if (
        !this.newEmailTemplateData.emailChecked &&
        !this.newEmailTemplateData.websiteChecked
      ) {
        this.notificationReceiverTypeErrorMsg =
          "At least one receiver type (Email or Website) must be selected.";
      }

      if (
        this.newEmailTemplateData.emailChecked &&
        !this.newEmailTemplateData.email_content
      ) {
        this.emailContentErrorMsg =
          "Email content is required when Email is selected.";
      }

      if (
        this.newEmailTemplateData.websiteChecked &&
        !this.newEmailTemplateData.web_or_mobile_content
      ) {
        this.webOrMobileContentErrorMsg =
          "Web or mobile content is required when Web/Mobile is selected.";
      }

      // Validate email tags
      const allInvalidTags: string[] = [];
      
      if (this.newEmailTemplateData.email_title) {
        const titleInvalidTags = this.validateEmailTags(this.newEmailTemplateData.email_title);
        allInvalidTags.push(...titleInvalidTags);
      }
      
      if (this.newEmailTemplateData.email_content) {
        const contentInvalidTags = this.validateEmailTags(this.newEmailTemplateData.email_content);
        allInvalidTags.push(...contentInvalidTags);
      }
      
      if (this.newEmailTemplateData.web_or_mobile_content) {
        const mobileInvalidTags = this.validateEmailTags(this.newEmailTemplateData.web_or_mobile_content);
        allInvalidTags.push(...mobileInvalidTags);
      }
      
      if (allInvalidTags.length > 0) {
        const uniqueInvalidTags = Array.from(new Set(allInvalidTags));
        this.emailContentErrorMsg = `Invalid email tags found: [${uniqueInvalidTags.join('], [')}]. Please use only available tags.`;
      }

      if (
        this.roleErrorMsg ||
        this.emailTitleErrorMsg ||
        this.emailNotificationTypeErrorMsg ||
        this.notificationReceiverTypeErrorMsg ||
        this.emailContentErrorMsg ||
        this.webOrMobileContentErrorMsg
      ) {
        return;
      }

      this.isFormSubmitting = true;
      try {
        const formData = new FormData();
        formData.append("email_title", this.newEmailTemplateData.email_title);
        if (this.newEmailTemplateData.roles !== null) {
          formData.append("roles", this.newEmailTemplateData.roles.toString());
        }
        if (this.newEmailTemplateData.email_notification_type !== null) {
          formData.append(
            "email_notification_type",
            this.newEmailTemplateData.email_notification_type.toString()
          );
        }
        formData.append(
          "notification_receiver_type",
          this.newEmailTemplateData.notification_receiver_type.toString()
        );
        if (
          this.newEmailTemplateData.notification_receiver_type === 1 ||
          this.newEmailTemplateData.notification_receiver_type === 3
        ) {
          formData.append(
            "email_content",
            this.newEmailTemplateData.email_content!
          );
        }
        if (
          this.newEmailTemplateData.notification_receiver_type === 2 ||
          this.newEmailTemplateData.notification_receiver_type === 3
        ) {
          formData.append(
            "web_or_mobile_content",
            this.newEmailTemplateData.web_or_mobile_content!
          );
        }
        formData.append("status", this.newEmailTemplateData.status.toString());

        await axios.post(`${API_BASE_URL}/email-templates/`, formData);
        Swal.fire({
          icon: "success",
          title: "Email Template Created Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        this.cancelNewEmailTemplateForm();
        await this.fetchCounts();
        await this.fetchAllEmailTemplates();
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
          this.currentPage = Math.ceil(
            this.counts[this.activeTab] / this.limit
          );
        }
        this.fetchEmailTemplates(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
      } catch (error: any) {
        console.error("Error creating email template:", error);
        Swal.fire({
          icon: "error",
          title: "Error creating email template.",
          text: error.response?.data?.error?.[0] || "Please try again.",
          showConfirmButton: true,
        });
      } finally {
        this.isFormSubmitting = false;
      }
    },
    cancelNewEmailTemplateForm() {
      this.newFormOpened = false;
      this.newEmailTemplateData = {
        id: 0,
        roles: null,
        email_title: "",
        email_notification_type: null,
        notification_receiver_type: 1,
        web_or_mobile_content: "",
        email_content: "",
        status: 0,
        emailChecked: true,
        websiteChecked: false,
      };
      this.roleErrorMsg = "";
      this.emailTitleErrorMsg = "";
      this.emailNotificationTypeErrorMsg = "";
      this.notificationReceiverTypeErrorMsg = "";
      this.emailContentErrorMsg = "";
      this.webOrMobileContentErrorMsg = "";
      this.lastActiveEditor = null;
      this.lastActiveInput = null;
      this.newTag = {
        key: "",
        value: null ,
        referenced_key: null,
      };
      this.emailTags = this.emailTags.map((tag) => ({
        ...tag,
        editing: false,
      }));
    },
    editEmailTemplate(index: number) {
      this.editFormOpened = true;
      this.newFormOpened = false;
      this.emailTemplateData.forEach((emailTemplate, i) => {
        emailTemplate.editing = i === index;
      });
      const selectedEmailTemplate = this.emailTemplateData[index];
      this.editEmailTemplateData = {
        id: selectedEmailTemplate.id,
        roles: selectedEmailTemplate.roles,
        email_title: selectedEmailTemplate.email_title,
        email_notification_type: selectedEmailTemplate.email_notification_type,
        notification_receiver_type:
          selectedEmailTemplate.notification_receiver_type,
        web_or_mobile_content:
          selectedEmailTemplate.web_or_mobile_content || "",
        email_content: selectedEmailTemplate.email_content || "",
        status: selectedEmailTemplate.status,
        emailChecked:
          selectedEmailTemplate.notification_receiver_type === 1 ||
          selectedEmailTemplate.notification_receiver_type === 3,
        websiteChecked:
          selectedEmailTemplate.notification_receiver_type === 2 ||
          selectedEmailTemplate.notification_receiver_type === 3,
      };
      this.lastActiveEditor = null;
      this.lastActiveInput = null;
      this.newTag = {
        key: "",
        value: null ,
        referenced_key: null,
      };
      this.emailTags = this.emailTags.map((tag) => ({
        ...tag,
        editing: false,
      }));
    },
    async submitEditEmailTemplateForm() {
      this.editRoleErrorMsg = "";
      this.editEmailTitleErrorMsg = "";
      this.editEmailNotificationTypeErrorMsg = "";
      this.editNotificationReceiverTypeErrorMsg = "";
      this.editEmailContentErrorMsg = "";
      this.editWebOrMobileContentErrorMsg = "";

      if (!this.editEmailTemplateData.roles) {
        this.editRoleErrorMsg = "Please select a role.";
      }

      if (!this.editEmailTemplateData.email_title) {
        this.editEmailTitleErrorMsg = "Email title is required.";
      }

      if (!this.editEmailTemplateData.email_notification_type) {
        this.editEmailNotificationTypeErrorMsg =
          "Notification type is required.";
      }

      this.validateRoleAndNotificationType(true);

      if (
        !this.editEmailTemplateData.emailChecked &&
        !this.editEmailTemplateData.websiteChecked
      ) {
        this.editNotificationReceiverTypeErrorMsg =
          "At least one receiver type (Email or Website) must be selected.";
      }

      if (
        this.editEmailTemplateData.emailChecked &&
        !this.editEmailTemplateData.email_content
      ) {
        this.editEmailContentErrorMsg =
          "Email content is required when Email is selected.";
      }

      if (
        this.editEmailTemplateData.websiteChecked &&
        !this.editEmailTemplateData.web_or_mobile_content
      ) {
        this.editWebOrMobileContentErrorMsg =
          "Web or mobile content is required when Web/Mobile is selected.";
      }

      // Validate email tags
      const allInvalidTags: string[] = [];
      
      if (this.editEmailTemplateData.email_title) {
        const titleInvalidTags = this.validateEmailTags(this.editEmailTemplateData.email_title);
        allInvalidTags.push(...titleInvalidTags);
      }
      
      if (this.editEmailTemplateData.email_content) {
        const contentInvalidTags = this.validateEmailTags(this.editEmailTemplateData.email_content);
        allInvalidTags.push(...contentInvalidTags);
      }
      
      if (this.editEmailTemplateData.web_or_mobile_content) {
        const mobileInvalidTags = this.validateEmailTags(this.editEmailTemplateData.web_or_mobile_content);
        allInvalidTags.push(...mobileInvalidTags);
      }
      
      if (allInvalidTags.length > 0) {
        const uniqueInvalidTags = Array.from(new Set(allInvalidTags));
        this.editEmailContentErrorMsg = `Invalid email tags found: [${uniqueInvalidTags.join('], [')}]. Please use only available tags.`;
      }

      if (
        this.editRoleErrorMsg ||
        this.editEmailTitleErrorMsg ||
        this.editEmailNotificationTypeErrorMsg ||
        this.editNotificationReceiverTypeErrorMsg ||
        this.editEmailContentErrorMsg ||
        this.editWebOrMobileContentErrorMsg
      ) {
        return;
      }

      this.isFormSubmitting = true;
      try {
        const formData = new FormData();
        formData.append("email_title", this.editEmailTemplateData.email_title);
        if (this.editEmailTemplateData.roles !== null) {
          formData.append("roles", this.editEmailTemplateData.roles.toString());
        }
        if (this.editEmailTemplateData.email_notification_type !== null) {
          formData.append(
            "email_notification_type",
            this.editEmailTemplateData.email_notification_type.toString()
          );
        }
        formData.append(
          "notification_receiver_type",
          this.editEmailTemplateData.notification_receiver_type.toString()
        );
        if (
          this.editEmailTemplateData.notification_receiver_type === 1 ||
          this.editEmailTemplateData.notification_receiver_type === 3
        ) {
          formData.append(
            "email_content",
            this.editEmailTemplateData.email_content!
          );
        }
        if (
          this.editEmailTemplateData.notification_receiver_type === 2 ||
          this.editEmailTemplateData.notification_receiver_type === 3
        ) {
          formData.append(
            "web_or_mobile_content",
            this.editEmailTemplateData.web_or_mobile_content!
          );
        }
        formData.append("status", this.editEmailTemplateData.status.toString());

        await axios.patch(
          `${API_BASE_URL}/email-templates/${this.editEmailTemplateData.id}/`,
          formData
        );
        Swal.fire({
          icon: "success",
          title: "Email Template Updated Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        this.cancelEditEmailTemplateForm();
        await this.fetchCounts();
        await this.fetchAllEmailTemplates();
        if (this.counts[this.activeTab] > this.limit * this.currentPage) {
          this.currentPage = Math.ceil(
            this.counts[this.activeTab] / this.limit
          );
        }
        this.fetchEmailTemplates(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
      } catch (error: any) {
        console.error("Error updating email template:", error);
        Swal.fire({
          icon: "error",
          title: "Error updating email template.",
          text: error.response?.data?.error?.[0] || "Please try again.",
          showConfirmButton: true,
        });
      } finally {
        this.isFormSubmitting = false;
      }
    },
    cancelEditEmailTemplateForm() {
      this.editFormOpened = false;
      this.emailTemplateData.forEach((emailTemplate) => {
        emailTemplate.editing = false;
      });
      this.editEmailTemplateData = {
        id: 0,
        roles: null,
        email_title: "",
        email_notification_type: null,
        notification_receiver_type: 1,
        web_or_mobile_content: "",
        email_content: "",
        status: 0,
        emailChecked: false,
        websiteChecked: false,
      };
      this.editRoleErrorMsg = "";
      this.editEmailTitleErrorMsg = "";
      this.editEmailNotificationTypeErrorMsg = "";
      this.editNotificationReceiverTypeErrorMsg = "";
      this.editEmailContentErrorMsg = "";
      this.editWebOrMobileContentErrorMsg = "";
      this.lastActiveEditor = null;
      this.lastActiveInput = null;
    },
    async switchView(status: string) {
      this.currentPage = 1;
      this.activeTab = status;
      this.selectedEmailTemplates = [];
      this.selectAll = false;
      await this.fetchEmailTemplates(status, this.limit, 0);
      if (status === "active") {
        this.totalPages = Math.ceil(this.counts.active / this.limit);
      } else if (status === "inActive") {
        this.totalPages = Math.ceil(this.counts.inActive / this.limit);
      }
    },
    async fetchCounts(searchedText?: string) {
      try {
        const baseUrl = `${API_BASE_URL}/email-templates/count/`;
        const queryParams = searchedText
          ? `?searchedText=${searchedText}&status=`
          : "?status=";

        const [activeResponse, inActiveResponse] = await Promise.all([
          axios.get(`${baseUrl}${queryParams}1`),
          axios.get(`${baseUrl}${queryParams}0`),
        ]);

        this.counts = {
          active: activeResponse.data.count,
          inActive: inActiveResponse.data.count,
        };

        if (this.activeTab in this.counts) {
          this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
        } else {
          console.error(`Invalid active tab: ${this.activeTab}`);
        }
      } catch (error) {
        console.error("Error fetching blog counts:", error);
      }
    },
    setDeleteMode(mode: "all" | "single", id?: number) {
      this.deleteMode = mode;
      if (id !== undefined) {
        this.emailTemplateToDelete = id;
      }
    },
    confirmDelete() {
      if (this.deleteMode === "all") {
        this.deleteSelectedEmailTemplates();
      } else if (this.deleteMode === "single") {
        this.deleteEmailTemplate();
      }
    },
    toggleSelectAll() {
      if (this.selectAll === true) {
        this.selectedEmailTemplates = [];
        this.selectAll = false;
      } else {
        this.selectedEmailTemplates = this.emailTemplateData.map(
          (emailTemplate) => emailTemplate.id
        );
        this.selectAll = true;
      }
    },
    toggleEmailTemplateSelection(selectedId: number) {
      if (this.selectedEmailTemplates.includes(selectedId)) {
        this.selectedEmailTemplates = this.selectedEmailTemplates.filter(
          (id) => id !== selectedId
        );
      } else {
        this.selectedEmailTemplates.push(selectedId);
      }
    },
    async deleteEmailTemplate() {
      try {
        await axios.delete(
          `${API_BASE_URL}/email-templates/${this.emailTemplateToDelete}/`
        );
        await this.fetchCounts();
        await this.fetchEmailTemplates(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        if (this.emailTemplateData.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchEmailTemplates(
            this.activeTab,
            this.limit,
            (this.currentPage - 1) * this.limit
          );
        }
        await this.fetchAllEmailTemplates();
        Swal.fire({
          icon: "success",
          title: "Email Template Deleted Successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error: any) {
        console.error("Error deleting email template:", error);
        Swal.fire({
          icon: "error",
          title: "Failed to delete email template",
          text: error.response?.data?.detail || "Please try again.",
          showConfirmButton: true,
        });
      }
    },
    async deleteSelectedEmailTemplates() {
      try {
        await axios.delete(`${API_BASE_URL}/email-templates/bulk-delete/`, {
          data: { ids: this.selectedEmailTemplates },
        });
        this.emailTemplateData = this.emailTemplateData.filter(
          (emailTemplate) =>
            !this.selectedEmailTemplates.includes(emailTemplate.id)
        );
        this.selectedEmailTemplates = [];
        this.selectAll = false;
        await this.fetchCounts();
        await this.fetchAllEmailTemplates();
        await this.fetchEmailTemplates(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        if (this.emailTemplateData.length === 0 && this.currentPage > 1) {
          this.currentPage--;
          await this.fetchEmailTemplates(
            this.activeTab,
            this.limit,
            (this.currentPage - 1) * this.limit
          );
        }
      } catch (error: any) {
        console.error("Error deleting email templates:", error);
      }
    },
    changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchEmailTemplates(
          this.activeTab,
          this.limit,
          (this.currentPage - 1) * this.limit
        );
        this.selectAll = false;
        this.selectedEmailTemplates = [];
      }
    },
    handleLimitChange() {
      setPaginationLimit("emailTemplates", this.limit);
      this.currentPage = 1;
      this.totalPages = Math.ceil(this.counts[this.activeTab] / this.limit);
      this.selectAll = false;
      this.selectedEmailTemplates = [];
      this.fetchEmailTemplates(this.activeTab, this.limit, 0);
    },
    toggleSort(field: string) {
        if (this.sortBy === field) {
            this.sortBy = `-${field}`; 
        } else if (this.sortBy === `-${field}`) {
            this.sortBy = '-created_at'; 
        } else {
            this.sortBy = field; 
        }
        this.fetchEmailTemplates(this.activeTab, this.limit, (this.currentPage - 1) * this.limit, this.sortBy);
    },
    validateRoleAndNotificationType(isEdit: boolean) {
      const data = isEdit
        ? this.editEmailTemplateData
        : this.newEmailTemplateData;
      const roleErrorMsgKey = isEdit ? "editRoleErrorMsg" : "roleErrorMsg";
      const notificationErrorMsgKey = isEdit
        ? "editEmailNotificationTypeErrorMsg"
        : "emailNotificationTypeErrorMsg";

      this[roleErrorMsgKey] = "";
      this[notificationErrorMsgKey] = "";

      const selectedRole = this.roles.find((role) => role.id === data.roles);
      const selectedType = this.notification_types.find(
        (type) => type.id === Number(data.email_notification_type)
      );

      const roleName = selectedRole?.name.toUpperCase();
      const typeTitle = selectedType?.title.toUpperCase();

      const isValid =
        (roleName?.includes("CANDIDATE") && typeTitle?.includes("CANDIDATE")) ||
        (roleName?.includes("RECRUITER") && typeTitle?.includes("HR"));

      if (!isValid) {
        this[roleErrorMsgKey] =
          "Please select a role that matches the selected notification type.";
        this[notificationErrorMsgKey] =
          "Please select a notification type that matches the selected role.";
      }
    },
    async fetchEmailTags() {
      try {
        const response = await axios.get(`${API_BASE_URL}/email-tags/`);
        this.emailTags = response?.data;
      } catch (error: any) {
        console.error("Error fetching tags:", error);
      }
    },
    openAndCloseList(isEdit: boolean) {
      if (isEdit) {
        this.isListOpenedForEditTag = !this.isListOpenedForEditTag;
      } else {
        this.isListOpenedForNewTag = !this.isListOpenedForNewTag;
      }
    },
    selectKey(id: number, isEdit: boolean) {
      const selectedKey = this.emailTags.find((tag) => tag.id === id);
      if (selectedKey) {
        if (isEdit) {
          this.editTag.referenced_key = selectedKey.id;
          this.editTag.value = selectedKey.key;
          this.isListOpenedForEditTag = false;
        } else {
          this.newTag.referenced_key = selectedKey.id;
          this.newTag.value = selectedKey.key;
          this.isListOpenedForNewTag = false;
        }
      }
    },
    async addFilterKey() {
      this.newTagErrors = {
        keyError: "",
        valueError: "",
      };
      try {
        if (!this.newTag.key) {
          this.newTagErrors.keyError = "Please add a key.";
          return;
        }
        const isCustomValue = !this.newTag.referenced_key;
        const payload = {
          key: this.newTag.key,
          value: isCustomValue ? this.newTag.value : null,
          referenced_key: isCustomValue ? null : this.newTag.referenced_key,
        };
        await axios.post(`${API_BASE_URL}/email-tags/`, payload);
        this.fetchEmailTags();
        this.newTag = {
          key: "",
          value: null,
          referenced_key: null,
        };
        this.isListOpenedForNewTag = false;
        Swal.fire({
          icon: "success",
          title: "Tag created successfully.",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error: any) {
        console.error("Error creating tag:", error);
        Swal.fire({
          icon: "error",
          title: "Error creating tag.",
          text: error.response?.data?.error?.[0] || "Please try again.",
          showConfirmButton: true,
        });
      }
    },
    startEditTag(tag: any): void {
      this.isListOpenedForEditTag = false;
      this.emailTags = this.emailTags.map((t) => ({
        ...t,
        editing: t.id === tag.id,
      }));
      this.editTag = {
        id: tag.id,
        key: tag.key,
        referenced_key: tag.referenced_key ? tag.referenced_key.id : null,
        value: tag.value
          ? tag.value
          : tag.referenced_key
          ? tag.referenced_key.key
          : "",
      };
    },
    async saveTagEdit() {
      this.editTagErrors = {
        keyError: "",
        valueError: "",
      };
      try {
        if (!this.editTag.key) {
          this.editTagErrors.keyError = "Please add a key.";
          return;
        }
        const isCustomValue = !this.editTag.referenced_key;
        const payload = {
          key: this.editTag.key,
          value: isCustomValue ? this.editTag.value : null,
          referenced_key: isCustomValue ? null : this.editTag.referenced_key,
        };
        await axios.patch(
          `${API_BASE_URL}/email-tags/${this.editTag.id}/`,
          payload
        );
        await this.fetchEmailTags();
        this.cancelTagEdit();
        this.isListOpenedForEditTag = false;
        Swal.fire({
          icon: "success",
          title: "Tag updated successfully.",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error: any) {
        console.error("Error updating tag:", error);
        Swal.fire({
          icon: "error",
          title: "Error updating tag.",
          text: error.response?.data?.error?.[0] || "Please try again.",
          showConfirmButton: true,
        });
      }
    },
    cancelTagEdit() {
      this.editTag.id = null;
      this.editTag.key = "";
      this.editTag.value = null;
      this.editTag.referenced_key = null;
      this.emailTags = this.emailTags.map((tag) => ({
        ...tag,
        editing: false,
      }));
    },
    async deleteTag(tagId: number) {
      try {
        await axios.delete(`${API_BASE_URL}/email-tags/${tagId}/`);
        await this.fetchEmailTags();

        Swal.fire({
          icon: "success",
          title: "Tag deleted successfully.",
          showConfirmButton: false,
          timer: 1500,
        });
      } catch (error: any) {
        console.error("Error deleting tag:", error);
        Swal.fire({
          icon: "error",
          title: "Error deleting tag.",
          text: error.response?.data?.error || "Please try again.",
          showConfirmButton: true,
        });
      }
    },
    insertTagIntoEditor(tagKey: string) {
      if (!this.lastActiveEditor && !this.lastActiveInput) {
        Swal.fire({
          icon: "error",
          title: "Error copying tag.",
          text: "Please place your cursor in the email message body or email title.",
          showConfirmButton: true,
        });
        return;
      }

      if (this.lastActiveEditor) {
        const editor = this.lastActiveEditor;
        const model = editor.model;
        const tag = `[${tagKey}]`;
        model.change((writer: any) => {
          const selection = model.document.selection;
          let position = selection.getLastPosition(); 
          if (!position) {
            const root = model.document.getRoot();
            position = writer.createPositionAt(root, "end");
          }
          writer.insertText(tag, position);
        });

        if (this.newFormOpened) {
          this.newEmailTemplateData.email_content = editor.getData();
        } else if (this.editFormOpened) {
          this.editEmailTemplateData.email_content = editor.getData();
        }
      } else if (this.lastActiveInput) {
        const tag = `[${tagKey}]`;
        const input = this.lastActiveInput;
        const startPos = input.selectionStart || 0;
        const endPos = input.selectionEnd || 0;
        const currentValue = input.value;
        const newValue =
          currentValue.substring(0, startPos) +
          tag +
          currentValue.substring(endPos);

        if (this.newFormOpened) {
          this.newEmailTemplateData.email_title = newValue;
        } else if (this.editFormOpened) {
          this.editEmailTemplateData.email_title = newValue;
        }
        this.$nextTick(() => {
          input.focus();
          input.setSelectionRange(startPos + tag.length, startPos + tag.length);
        });
      }
    },
    onNewEditorReady(editor: any) {
      editor.editing.view.document.on("click", () => {
        this.lastActiveEditor = editor;
        this.lastActiveInput = null;
      });
    },
    onEditEditorReady(editor: any) {
      editor.editing.view.document.on("click", () => {
        this.lastActiveEditor = editor;
        this.lastActiveInput = null;
      });
    },
    setActiveInput(event: Event) {
      this.lastActiveInput = event.target as HTMLInputElement;
      this.lastActiveEditor = null;
    },
    handleOutsideClick(event: MouseEvent) {
      const emailTagsDivs = document.querySelectorAll(".lmd-custom-select-box");
      const target = event.target as HTMLElement;

      if (this.isListOpenedForNewTag || this.isListOpenedForEditTag) {
        const isInsideEmailTags = Array.from(emailTagsDivs).some((div) =>
          div.contains(target)
        );
        if (!isInsideEmailTags) {
          this.isListOpenedForNewTag = false;
          this.isListOpenedForEditTag = false;
        }
      }
    },
    async fetchAllEmailTemplates() {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/email-templates/?status=0&status=1`,
          {
            params: { no_pagination: true },
          }
        );
        this.usedNotificationTypeIds = Array.from(
          new Set(
            response?.data
              .map((template: any) => template.email_notification_type)
              .filter((id: number | null) => id !== null)
          )
        );
      } catch (error: any) {
        console.error("Error fetching all email templates:", error);
      }
    },
  },
});
</script>
